<template>
  <div class="card mb-4">
    <div class="card-header">
      <div class="row flex-between-end">
        <div class="col-auto text-center">
          <h5 class="mb-0" data-anchor="data-anchor">Delete Account</h5>
        </div>
      </div>
    </div>
    <div class="card-body bg-body-tertiary">
      <div>
        <p class="mb-4">
          We are really sorry to see you go!<br>
          If you can think of something that we could do better to have you back, <a href="mailto:support@signum.money"><span class="fw-bold">drop us a line</span></a> ❤️
        </p>
      </div>

      <div v-if="canDeleteAccount">
        <!-- <div class="alert alert-danger border-0" role="alert">
          <p class="mb-0"><strong>Warning:</strong> Deleting your account will permanently remove all your data immediately. This action is irreversible.</p>
        </div> -->

        <div v-if="deleteError" class="alert alert-danger border-0 mt-3" role="alert">
          <p class="mb-0">{{ deleteError }}</p>
        </div>

        <div class="row mt-4">
          <div class="col d-flex justify-content-end">
            <button @click="confirmDelete()" type="button" class="btn btn-danger">Delete My Account</button>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="alert alert-warning border-0 d-flex align-items-center" role="alert">
          <div class="bg-warning me-3 icon-item"><span class="fas fa-exclamation-triangle text-white fs-6"></span></div>
          <div class="flex-1">
            <p class="mb-1">You have an active subscription. You must cancel your subscription before you can delete your account.</p>
            <router-link :to="{name: 'Subscription'}" class="btn btn-sm btn-warning mt-2">Go to Subscription</router-link>
          </div>
        </div>
      </div>

    </div>
  </div>

  <SimpleModal ref="modalRef" :loading="loading" />
</template>

<script>
import SimpleModal from '@/components/SimpleModal'

export default {
  components: {
    SimpleModal
  },
  props: {
    userProfile: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      deleteError: null
    }
  },
  computed: {
    canDeleteAccount () {
      return !(this.userProfile?.subscriptionStatus == 'subscribed' || this.userProfile?.subscriptionStatus == 'grace')
    },
    botCount () {
      const bots = this.$store.getters.getUserBots
      return bots ? bots.length : 0
    }
  },
  methods: {
    confirmDelete () {
      this.$refs.modalRef.setValues({
        title: 'Delete Account?',
        message: 'Are you sure you want to <span class="fw-bold">permanently delete</span> your account <span class="fw-bold">' + this.userProfile.email + '</span>?' + (this.botCount > 0 ? ' <br><br>Your ' + this.botCount + ' Bot' + (this.botCount > 1 ? 's' : '') + ' will also be deleted.' : '') + ' All your data & logs will be deleted immediately. <br><br>This action cannot be undone!',
        callback: async () => {
          await this.deleteAccount()
        }
      })
      this.$refs.modalRef.toggleModal(true)
    },
    async deleteAccount () {
      this.loading = true
      this.deleteError = null

      const jsonResponse = await this.$store.dispatch("deleteUserAccount")

      if (jsonResponse.error) {
        this.deleteError = jsonResponse.error
      } else {
        this.$store.dispatch("logout")
        this.$posthog.reset()
        window.location.href = process.env.VUE_APP_LP_URL
      }

      this.loading = false
    }
  },
  async created () {
    // Needs getUserBots to display how many Bots will be deleted
    if (!this.$store.getters.getUserBots) await this.$store.dispatch('getUserBots')
  }
}
</script>
